
// source of the recovery links in the cart attribute `from` ( LPO_recover )
export const RECOVER_SOURCE = 'recover';

// source of a saved configuration link ( ?cl_config ) in the cart attribute `from` ( LPO_saved )
export const SAVED_SOURCE = 'saved';

// view state property of a preview ( __v, __v_<view> ) - restored with a cart item or a saved configuration
export const PREVIEW_STATE = /^__v(_[a-z0-9_]+)?$/;

export const CartItemProperties = {
    OPTIONS: '_cl_options',
    ID: '_cl_options_id',
    PRICE: '_cl_options_price',
    PRICE_BASE: '_cl_options_price_base',
    PRICE_KEY: '_cl_options_price_key',
    CURRENCY: '_cl_options_currency',
    WEIGHT: '_cl_options_weight',
    QUANTITY_ID: '_cl_options_quantity_id',
    QUANTITY_DISCOUNT: '_cl_options_quantity_discount',
    QUANTITY_MIN: '_cl_options_quantity_min',
    QUANTITY_UNIT: '_cl_options_quantity_unit',
    QUANTITY_TEXT: '_cl_options_quantity_t',
    BUNDLE: '_cl_options_bundle',
    BUNDLE_TITLE: '_cl_options_bundle_title',
    JSON: '_cl_options_json',
    JSON_PRICE: '_cl_options_json_price',
    PREVIEW: '_preview' // preview image of the line ( the live preview of the add to cart )
};

export const ThemeConfig = {
    formInject: true, // flag to auto inject options on product form (default true - root disable)
    cartItem: true,
    cartItemPreview: true,
    cartItemPreviewViews: true, // preview all views (first match _preview then preview_*)
    cartItemPrice: true,
    cartItemPriceOptions: true,
    cartItemEdit: false,
    cartItemClOptions: true,
    cartItemPriceRemove: true, // flag to disable removing of the price add-on item element
    cartCount: true,
    cartTotal: true,
    cartFormCapture: true,
    cartDiscount: false,
    cartSaveBtn: false, // NEW: auto inject the save cart button above the checkout buttons ( cart drawers without app block support )
    cartPriceRegex: false, // admin only flag to search for price matches with regex
    checkoutDomain: false, // admin only flag to redirect draft order invoice url to current domain (seems to be required for checkout on multi market domains)
    productFormCapture: true, // captures every click on the form to execute the form handler before the theme
    productAjaxInject: false, // NEW: inject properties into ajax cart/add requests (monkey patch)
    productFormDisabled: true, // disable button during add to cart preventSubmit process
    productFormSubmitDelay: false, // NEW: delay before resetting the submit flag for other app compatibly issues (root only)
    productFormValidityPatch: false, // NEW: patch form.checkValidity to trigger app validation
    productBuyNow: true, // NEW: flag to take over buy now button - was always enabled before - now can be disabled via admin TODO this flag can be removed when buy now buttons (e.g paypal) are verified to work with all themes
    productPrice: true,
    productPriceAll: false, // update all product price matches (required to support product price on add to cart button)
    productPriceComparePct: false, // NEW: flag to show percentage instead of absolute compare at price difference (only disable if merchant requests it)
    productVariantHide: true,
    productVariantFilter: true, // always filter variant values to only show possible combinations
    productVariantObserver: false, // register mutation observer to detect if the variant element was removed (Dawn auto enabled - other themes could be enabled via theme_config.json)
    productVariantChange: true, // watch form "change" event (default enabled - only disable for edge case themes)
    productVariantHistory: false, // watch history for variant changes
    productVariantHistoryPush: true, // watch history.pushState for variant changes (only if productVariantHistory true)
    productVariantHistoryReplace: true, // watch history.replaceState for variant changes (only if productVariantHistory true)
    productLinkAvailable: false, // linked products variant available check
    productVariantExcludeTotal: false, // BETA: flag to exclude add-on variant price from total product price
    productPriceDeductVP: false, // BETA: flag to subtract main variant price from total product options price
    productPriceTimeout: false,
    productPriceObserver: false, // register mutation observer to detect if the product price element was removed
    productItemUpdate: true, // update via ?item= is enabled by default (currently backend setting is not shown)
    productItemModal: false,
    productOptionsClear: false,
    productOptionsEmptyId: false, // skip adding _cl_options property if all option values are empty
    productOptionsEmptyExclude: false, // exclude all empty properties on add to cart (experimental)
    bundlePriceVariant: false, // BUNDLE extension: use all linked priceVariant as bundle items
    bundleCartLayout: true, // BUNDLE extension: show bundle items in cart
    bundleCartLayoutOptions: false, // BUNDLE extension: also show the bundle layout for options price only items (add-on product)
    productCropOverlay: true, // flag if cropping should show an overlay (currently only used for cropping by dimension input)
    productSKU: false, // flag to calculate SKU based on selected options
    productQuickView: false, // flag to enable quick view click listeners (currently manual enabled only)
    amountNoDecimals: false, // fallback to search money amount without decimals - some themes use 'money_without_trailing_zeros' filter  docs: https://shopify.dev/api/liquid/filters/money-filters
    themeGallery: false, // auto select theme gallery thumbnail when preview changes
    themeGalleryTimeout: false, // timeout to autoSelect theme gallery thumbnail
    previewHiddenExclude: false, // check if preview is visible before initializing live preview (required for themes with two separate sections desktop/mobile)
    tooltipBody: true, // default append tooltips to body (better to avoid z-index issues - but some themes require this setting to be set to false to avoid tooltip location issues)
    currencyFormat: true, // flag if currency format is updated based on window.theme variable (in options-app) - only disable for edge cases with 3rd party currency conversion apps
    priceVisible: true, // flag can be toggled to hide prices on UI
    priceVisibleCustomer: false, // flag to only show prices for logged in customers (controls priceVisible)
    previewCdnSize: true, // flag to add dynamic shopify CDN image size parameter to dimension on preview (NEW enabled for all merchants - speeds up CDN loading)
    previewState: true, // NEW: serialize preview objects coordinates as state - enabled by default - disable on request or issues
    previewExportLog: true, // flag to log export (currently active for gathering data)
    previewExportRequired: false, // flag to only add to cart when export was successful
    previewBlobs: false, // flag to export blobs in preview - removeBG + export extension (only enabled on request)
    previewExportEmbed: false, // flag to embed SVG export (root only) - maybe make default in the future
    previewImgResize: false, // flag to resize large images when rendered scaled down (only enabled on request)
    checkoutLog: false, // flag to log checkout events (admin enable for debugging)
    checkoutQuantityValidate: false, // NEW: flag to store min quantity on cart item and validate on checkout
    evaluateOptionPriceHidden: false, // NEW: flag to evaluate all options price even if hidden by conditions (root only) store: e42d9f-4c
};

export const ThemeCurrency = {
    currency: '', // current selected shop currency
    currencyConvert: false, // flag to enable currency conversion
    currencyFactor: 1, // options currency convert,
    moneyFormat: '$ {{amount}}', // current money format
    moneyFormatWithCurrency: '${{amount}} USD', // current money format,
    priceVariant: false,
    priceVariantValue: 0.01, // if priceVariant = true , all prices need to be divided by this value (the value changes depending on the current currency)
    priceVariantId: '', // required to add priceVariant to cart
    priceProductHandle: '', // custom handle of priceVariant product to fetch in current currency
    checkout: { key: '', update: false, negative: false, validate: false, json: true }, // checkout extensibility config returned app.config
}

export const currencyConvert = (price) => {
    if(ThemeCurrency.currencyFactor !== 1){
        price *= ThemeCurrency.currencyFactor;
        //--- rounding
        if(ThemeCurrency.priceVariant){
            let quantity = Math.round(price / ThemeCurrency.priceVariantValue);
            // re calculate total => can change because of multi currency rounding of the options price product
            price = ThemeCurrency.priceVariantValue * quantity;
            // round 2 decimal (money format can do more rounding)
            price = Math.round(price * 100) / 100;
        } else {

            /* INFO: the converted price is charged by our own cart transform (SAME CODE there - keep in sync), so the rounding is our choice
               Graduated ceil: larger prices ceil to full dollars: small prices stay exact (a full dollar ceil would multiply them e.g 0.05 > 1).
               This covers most cases without the need for settings per market.

               NOTE: shopify markets now has rounding settings per market but liquid does not expose them - if merchants
               ever need exact matching we could sync the setting via the app backend (checkout + cart transform). */

            // integer cents - float dust must not tip exact values over a step (e.g 1.10 > 1.2)
            let cents = Math.round(price * 100);

            // high currency factor means large numbers (e.g JPY) > full number: 4.5 > 5, above 100 ceil to 100: 382.4 > 400
            if(ThemeCurrency.currencyFactor > 100){
                price = cents >= 10000 ? Math.ceil(cents / 10000) * 100 : Math.ceil(cents / 100);
            }
            else if(cents >= 1000){ price = Math.ceil(cents / 100); } // full dollar: 12.30 > 13
            else if(cents >= 100){ price = Math.ceil(cents / 10) / 10; } // 10 cent steps: 1.02 > 1.10
            else { price = cents / 100; } // exact cents: 0.045 > 0.05
        }

    }
    return price;
}

export const DiscountType = {
    NONE: 0,
    CODE: 1,
    AUTO: 2
}

export const PriceType = {
    ABSOLUTE: 1, // (default)
    PERCENTAGE: 2,
    LETTER: 3,
    FORMULA: 4,
    UPLOAD: 5    // price per uploaded file
}

export const AppExtensions = {
    EXPORT: false,
    FORMULA: false,
    QUANTITY: false,
    BUNDLE: false,
    AI: false
}
